import {
  PathwayOptionToRedirectUrlMapping,
  PathwayOptionToRedirectUrlMappingV2,
  PathwaysRedirectUrls,
} from './constants'

export interface CustomForkedTriageOption {
  label: string
  onPress: () => void
  minAge?: number
}

export const prepareCustomForkedTriageOptions = (
  customForkedTriageOptions: CustomForkedTriageOption[] | undefined,
  userAge: number | undefined,
  onCustomForkedTriageOptionPress?: (programDetail: string) => void,
): CustomForkedTriageOption[] =>
  (customForkedTriageOptions ?? [])
    .filter((option) => !option.minAge || (userAge != null && userAge >= option.minAge))
    .map((option) => ({
      ...option,
      onPress: () => {
        onCustomForkedTriageOptionPress?.(option.label)
        option.onPress()
      },
    }))

export const pathwaysRedirectToTriage = (redirectUrl: string | null) => {
  return redirectUrl === PathwaysRedirectUrls.SELF_TRIAGE || redirectUrl === PathwaysRedirectUrls.CHILD_TRIAGE
}

// TODO Hacky mapping to support essentials graphQL language code
export const translateToEssentialSiteCode = (lyraLanguage: string = '') => {
  const ESSENTIAL_DEFAULT_CODE = 'en'
  const essentialFormat = lyraLanguage.replace('-', '_').toLowerCase()
  switch (lyraLanguage) {
    case 'en-US':
    case '':
      return ESSENTIAL_DEFAULT_CODE
    case 'fil':
      return 'fil_ph'
    default:
      return essentialFormat
  }
}

export const getPathwayOptionToRedirectUrlMapping = (forkedTriageV2Enabled: boolean) => {
  return forkedTriageV2Enabled ? PathwayOptionToRedirectUrlMappingV2 : PathwayOptionToRedirectUrlMapping
}
